import { observer } from 'mobx-react';
import * as React from 'react';

const postConferenceTourImage = require('../resources/postConferenceTours.png'); 

export const PostConferenceTour = observer((props: {}) => (
  <div className="cover bg-left bg-center-l">
    <div className="center">
      <div className="cf" style={{backgroundColor: '#9fc5f8'}}>
        <div className="fl w-100">
          <p className="tc pv2 fw5 f2 bg_orange white">Tour Location</p>
        </div>
        <div className="fl w-100 pa2">
          <p className="b center f4 mw8">
            We want our delegates to experience a qualityful time in Cox’s Bazar, 
            the world’s longest natural sandy sea beach!
            We have arranged a number of tours which delegates can book after the conference.
          </p>
          <p className="b center f4 mb0 mw8">
             Conference participants will have the chance to experience the culture,
              history and nature of Beautiful Bangladesh by visiting some of the most significant and
               distinctive archaeological and historical sites.
          </p>
        </div>
        <div className="fl w-100 pa2">
          <p className="tc mb0">
            <img src={postConferenceTourImage} alt=" Post Conference Tour "/>
          </p>
        </div>
      </div>
    </div>
  </div>
));


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/PostConferenceTour.tsx